/**
 * Recall reminders and remaining benefits for staff: recall reminder results,
 * the year-end "use your benefits" campaign preview, and the patient-portal
 * preview. The Family File and huddle panels are exported from ./components.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'care-outreach',
    title: 'Recall and benefits outreach',
    version: '0.1.0',
    owner: 'WP4-PORTAL-RECALL',
    entitlementKey: null,
    permissions: ['comms.view', 'patient.view', 'insurance.view'],
    routes: [
      {
        id: 'results',
        path: '/care-outreach/recall-results',
        title: 'Recall results',
        permission: 'comms.view',
        officeScope: 'location-or-all',
        readsPhi: false,
      },
      {
        id: 'campaign',
        path: '/care-outreach/benefits-campaign',
        title: 'Year-end benefits campaign',
        permission: 'comms.view',
        officeScope: 'location-or-all',
        readsPhi: true,
      },
      {
        id: 'portal',
        path: '/care-outreach/portal-preview',
        title: 'Portal preview',
        permission: 'patient.view',
        officeScope: 'location-or-all',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Recall results',
        group: 'analytics',
        routeId: 'results',
        icon: 'trending-up',
        order: 60,
      },
      {
        label: 'Benefits campaign',
        group: 'operations',
        routeId: 'campaign',
        icon: 'badge-percent',
        order: 60,
      },
    ],
    commands: [
      {
        id: 'care-outreach.results',
        title: 'Recall reminder results',
        keywords: ['recall', 'reminders sent', 'booked', 'revenue scheduled'],
        routeId: 'results',
      },
      {
        id: 'care-outreach.campaign',
        title: 'Use your benefits before they reset',
        keywords: ['year end', 'benefits', 'insurance', 'campaign', 'unscheduled treatment'],
        routeId: 'campaign',
      },
      {
        id: 'care-outreach.portal',
        title: 'Preview the patient portal',
        keywords: ['portal', 'view as patient', 'next cleaning'],
        routeId: 'portal',
      },
    ],
    phiReadPoints: [
      'benefits.patient',
      'benefits.unused',
      'benefits.campaign',
      'portal-care.preview',
    ],
  }),
  pages: {
    results: () => import('./pages/RecallResultsPage.js'),
    campaign: () => import('./pages/BenefitsCampaignPage.js'),
    portal: () => import('./pages/PortalPreviewPage.js'),
  },
});
